export const RECEIVED_CUSTOMER = "RECEIVED_CUSTOMER";
export const CHECKING_CUSTOMER = "CHECKING_CUSTOMER";
export const SEND_SUCCESS = "SEND_SUCCESS";

export function checkCustomer(serialNum, latitude, longitude) {
  let endpoint;
  if (latitude === null || longitude === null) {
    endpoint = "/installer/remediation/address?serial_number=" + serialNum;
  } else {
    endpoint =
      "/installer/remediation/address?serial_number=" +
      serialNum +
      "&latitude=" +
      latitude +
      "&longitude=" +
      longitude;
  }
  return {
    type: CHECKING_CUSTOMER,
    meta: {
      endpoint: endpoint,
      success: checkCustomerSuccess,
    },
  };
}

export function sendSuccess(serialNum) {
  return {
    type: SEND_SUCCESS,
    meta: {
      endpoint: "/installer/remediation/complete",
      method: "POST",
      body: {
        serialNum: serialNum,
      },
    },
  };
}

function checkCustomerSuccess(response) {
  return {
    type: RECEIVED_CUSTOMER,
    payload: { ...response.data },
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/remediation.js